import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import type Transition from '@ember/routing/transition';
import { service } from '@ember/service';
import type CurrentAdminService from 'garaje/services/current-admin';
import type FeatureFlagsService from 'garaje/services/feature-flags';
import type GlobalOverviewAccessService from 'garaje/services/global-overview-access';
import type MetricsService from 'garaje/services/metrics';
import type StateService from 'garaje/services/state';
import type UserFeatureFlagsService from 'garaje/services/user-feature-flags';
import { AnalyticsEventNames } from 'garaje/utils/enums';

import type GlobalAnalyticsDesksIndexController from './controller';

export default class GlobalAnalyticsDesksIndexRoute extends Route {
  title = 'Desks · Global Analytics · Envoy';

  @service declare globalOverviewAccess: GlobalOverviewAccessService;
  @service declare router: RouterService;
  @service declare featureFlags: FeatureFlagsService;
  @service declare userFeatureFlags: UserFeatureFlagsService;
  @service declare metrics: MetricsService;
  @service declare currentAdmin: CurrentAdminService;
  @service declare state: StateService;

  afterModel(): void {
    this.#logMetrics();
  }

  setupController(controller: GlobalAnalyticsDesksIndexController, model: void, transition: Transition): void {
    super.setupController(controller, model, transition);

    if (
      this.featureFlags.isEnabled('sigma-embedded-analytics') ||
      this.userFeatureFlags.isEnabled('sigma-embedded-analytics-by-user')
    ) {
      void controller.fetchSigmaUrlTask.perform();
    }
  }

  redirect(): void {
    if (!this.globalOverviewAccess.canVisitConsolidatedDesksAnalytics) {
      this.router.transitionTo('unauthorized');
    }
  }

  #logMetrics(): void {
    const companyId = this.state?.currentCompany?.id;
    const details = {
      companyId,
      app: this.state.workplaceSubscription?.app,
      plan: this.state?.workplaceSubscription?.plan,
      userId: this.currentAdmin?.id || '',
      employeeId: this.currentAdmin.employee?.id || '',
    };
    this.metrics.trackEvent(AnalyticsEventNames.DESKS_GLOBAL_DASHBOARD_VISITED, details);
    this.metrics.logMonitorEvent(AnalyticsEventNames.DESKS_GLOBAL_DASHBOARD_VISITED, details);
  }
}
